import { createAction, handleActions } from 'redux-actions';

const SET_SIDO = 'searchAddr/SET_SIDO';
const SET_SIGUNGU = 'searchAddr/SET_SIGUNGU';

export const setSido = createAction(SET_SIDO);
export const setSigungu = createAction(SET_SIGUNGU);


const searchAddr = handleActions(
  {
    [SET_SIDO]: (state, action) => {
      return {
        ...state,
        sido: action.payload,
      };
    },
    [SET_SIGUNGU]: (state, action) => {
      return {
        ...state,
        sigungu: action.payload,
      };
    },
  },
  {
    sido: '',
    sigungu: '',
  }
);

export default searchAddr;
